module.exports = __webpack_public_path__ + "img/quxiao6_h5.eef712a.jpg";